'use strict';

angular.module('core').controller('RedirectController', ['$scope', '$state', '$stateParams', '$location', '$window', 'ConfigData',
	function($scope, $state, $stateParams, $location, $window, ConfigData) {

		// Redirects pages from old Angular pages to
		// new static versions.
		var redirectUrl = ConfigData.applanga.website + $state.current.name + '.html';
		var hash = $location.hash();
		if (hash) {
			redirectUrl += '#' + hash;
		}

		$window.location.href = redirectUrl;
	}
]);
